import script from "./ExamSkillReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamSkillReport.vue?vue&type=script&setup=true&lang=ts"

import "./ExamSkillReport.vue?vue&type=style&index=0&id=189ad815&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189ad815"]])

export default __exports__